import { render, staticRenderFns } from "./LicenseDetailsGeneralData.vue?vue&type=template&id=8930b210&"
import script from "./LicenseDetailsGeneralData.vue?vue&type=script&lang=js&"
export * from "./LicenseDetailsGeneralData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports